import { render } from "./GuideButton.vue?vue&type=template&id=3d0b969a"
import script from "./GuideButton.vue?vue&type=script&lang=js"
export * from "./GuideButton.vue?vue&type=script&lang=js"

import "./GuideButton.vue?vue&type=style&index=0&id=3d0b969a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__